import { c as _c } from "react/compiler-runtime";
import type React from "react";
import { useIsMobile } from "@/hooks/use-mobile";
import { cn } from "@/lib/utils";
export interface ModuleTabsProps<T extends string = string> {
  tabs: {
    key: T;
    label: React.ReactNode;
  }[];
  activeKey: T;
  onChange: (key: T) => void;
  className?: string;
}
export function ModuleTabs(t0) {
  const $ = _c(12);
  const {
    tabs,
    activeKey,
    onChange,
    className
  } = t0;
  useIsMobile();
  let t1;
  if ($[0] !== className) {
    t1 = cn("flex gap-8 border-b md:border-t md:border-b-0 mb-2.5 md:mb-0", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeKey || $[3] !== onChange || $[4] !== tabs) {
    let t3;
    if ($[6] !== activeKey || $[7] !== onChange) {
      t3 = tab => <button type="button" key={tab.key} className={cn("-mb-px font-medium  transition-colors duration-150 ease-in-out focus:outline-none", "  py-4 text-sm md:text-base leading-none", activeKey === tab.key ? "   text-destructive " : " text-hint hover:text-destructive ")} onClick={() => onChange(tab.key)}>{tab.label}</button>;
      $[6] = activeKey;
      $[7] = onChange;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = tabs.map(t3);
    $[2] = activeKey;
    $[3] = onChange;
    $[4] = tabs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function ModuleTabsWithIndicator(t0) {
  const $ = _c(14);
  const {
    tabs,
    activeKey,
    onChange,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("border-b border-gray-200 relative bg-white  ", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== activeKey || $[3] !== onChange || $[4] !== tabs) {
    let t3;
    if ($[6] !== activeKey || $[7] !== onChange) {
      t3 = tab => <button type="button" key={tab.key} onClick={() => onChange(tab.key)} className={cn("   py-3 text-sm font-regular border-b-2 transition-colors duration-200 text-center relative text-nowrap ", activeKey === tab.key ? "text-primary font-medium  border-destructive" : "text-hint hover:text-primary border-transparent")}>{tab.label}</button>;
      $[6] = activeKey;
      $[7] = onChange;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = tabs.map(t3);
    $[2] = activeKey;
    $[3] = onChange;
    $[4] = tabs;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="flex flex-row flex-nowrap justify-around">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  let t4;
  if ($[11] !== t1 || $[12] !== t3) {
    t4 = <div className={t1}>{t3}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}